import { supabaseClient, supabaseCoreClient } from './supabase';
import {
  deriveRepOnlyNavigation,
  type RepOnlyNavigationState,
} from './repOnlyNavigationState';

export { deriveRepOnlyNavigation } from './repOnlyNavigationState';
export type { RepOnlyNavigationState } from './repOnlyNavigationState';

export async function loadRepOnlyNavigation(appUserId: number): Promise<RepOnlyNavigationState> {
  const membershipsPromise = supabaseCoreClient
    .from('app_group_member')
    .select('app_group_id')
    .eq('app_user_id', appUserId);
  const repsPromise = supabaseClient
    .from('rep')
    .select('id')
    .eq('app_user', appUserId)
    .limit(2);

  const [{ data: memberships, error: membershipError }, { data: reps, error: repError }] =
    await Promise.all([membershipsPromise, repsPromise]);
  if (membershipError) throw membershipError;
  if (repError) throw repError;

  const groupIds = [...new Set(
    (memberships ?? [])
      .map((membership) => membership.app_group_id)
      .filter((id): id is number => typeof id === 'number'),
  )];

  let groupNames: string[] = [];
  if (groupIds.length > 0) {
    const { data: groups, error: groupsError } = await supabaseCoreClient
      .from('app_group')
      .select('name')
      .in('id', groupIds);
    if (groupsError) throw groupsError;
    groupNames = (groups ?? []).map((group) => group.name);
  }

  return deriveRepOnlyNavigation(
    groupNames,
    (reps ?? []).map((rep) => rep.id),
  );
}
